<template>
  <div class="popup" id="popup">
    <div class="popup__content">
      <!-- <span class="popup__quit"> <a href=""></a></span> -->
      <div class="popup__left">
        <div class="popup__images-1">
          <!-- <img src="../assets/bacalar.jpg" alt="" /> -->
        </div>
        <div class="popup__images-2">
          <!-- <img src="../assets/bacalar.jpg" alt="" /> -->
        </div>
      </div>
      <div class="popup__right">
        <a href="#section-tours" class="popup__close">&times;</a>
        <h1 class="popup__text--title heading-secondary">
          Empieza a viajar
        </h1>
        <h3 class="popup__text--subtitle heading-tertitary">
          Importante: Recuerda leer los términos antes de reservar
        </h3>
        <p class="popup__text--paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
        <a href="#" class="btn btn-red">Reserva ahora 🔥</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pop_up",
};
</script>

<style></style>
